import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { AuthStoreType } from '@/common/store/authStorage/useAuthStorage.type.ts';

const useAuthStorage = create<AuthStoreType>()(
  persist(
    (set) => ({
      token: '',
      removeToken: () => set({ token: '' }),
      setToken: (token) => set({ token }),
    }),
    {
      name: 'auth-storage',
    },
  ),
);
export default useAuthStorage;
